import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { fetchStudentById } from '../reducers/StudentSlice';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';

const ViewStudents = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { student, status, error } = useSelector(state => state.students);

    useEffect(() => {
        if (id) {
            dispatch(fetchStudentById(id));
        }
    }, [id, dispatch]);

    if (status === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed') {
        return <div>Failed to load student data: {error}</div>;
    }

    if (!student) {
        return <div>No student data available.</div>;
    }

    return (
        <div className="container my-4 text-white view-student">
            <div className="row" id="studentContainer">
                <div className="col">
                    <div className="card-body">
                        <div className="card student-card p-4">
                            <h2 className='text-center text-white mb-2'>AK Boys Hostel</h2>
                            <div className="d-flex align-items-center mb-3">
                                <img
                                    // src={`http://localhost:8000/uploads/${student.image}`}
                                    src={`https://ak-boys-hostel-server.onrender.com/uploads/${student.image}`}
                                    alt="Student Picture"
                                    className="me-3 rounded"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                <div>
                                    <h5 className="card-title mb-0">{student.studentName}</h5>
                                    <p className="text-mute mb-0">{student.department}</p>
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="table-auto w-100 border border-gray-300 text-white shadow-md rounded-lg">
                                    <tbody>
                                        {[
                                            ["Customer ID", student?._id, "Father's Name", student?.fatherName],
                                            ["Email", student?.email, "Date of Birth", student?.dob ? moment(student.dob).format("DD-MM-YYYY") : ""],
                                            ["CNIC", student?.cnic, "Gender", student?.gender],
                                            ["City", student?.city, "Contact", student?.contactNumber],
                                            ["Joining Date", student?.joinDate ? moment(student.joinDate).format("DD-MM-YYYY") : "", "Address", student?.currentAddress],
                                            ["Permanent Address", student?.permanentAddress, "Emergency Contact", student?.emergencyContact],
                                            ["Year", student?.currentYear, "Semester", student?.semester],
                                            ["Blood Group", student?.bloodGroup]
                                        ].map((row, rowIndex) => (
                                            <tr key={rowIndex} className="border-b border-gray-300">
                                                {row.map((cell, cellIndex) => (
                                                    <td key={cellIndex} className="px-4 py-2 border border-gray-300">
                                                        <strong>{cellIndex % 2 === 0 ? cell : ""}</strong> {cellIndex % 2 !== 0 ? cell : ""}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewStudents;
